import './App.scss';

import Game from './components/Game/index';
import React from 'react';

const App = () => <Game />;

export default App;
